module.exports = __webpack_public_path__ + "img/img22.17b6f8b6.png";